import { ERGANI_MARK, erganiComparableValue, erganiMarkerLabel, erganiMarkerState } from "../../lib/erganiSlots";

const TONE = {
  [ERGANI_MARK.MATCH]: { color: "#3730A3", bg: "#E0E7FF", border: "#6366F1" },
  [ERGANI_MARK.MISSING]: { color: "#4338CA", bg: "#fff", border: "#A5B4FC" },
  [ERGANI_MARK.DRIFT]: { color: "#9A3412", bg: "#FFEDD5", border: "#F97316" },
};

export function ErganiSlotMarker({ internalValue, erganiRow, known = true, lang, onClick }) {
  const state = erganiMarkerState(internalValue, erganiRow);
  const agrees = known && state === ERGANI_MARK.MATCH && Boolean(erganiRow);
  if (!agrees && state === ERGANI_MARK.MATCH) return null;
  const tone = agrees ? TONE[ERGANI_MARK.MATCH] : (TONE[state] || TONE[ERGANI_MARK.MISSING]);
  const gr = lang === "gr";
  const title = !known
    ? (gr ? "Το Εργάνη δεν έχει φορτωθεί" : "Ergani is not loaded")
    : agrees && !erganiRow
    ? (gr ? "Κενό και στο Εργάνη" : "Ergani is empty too")
    : (erganiMarkerLabel(state, lang) || (gr ? "Διαφέρει από το Εργάνη" : "Differs from Ergani"));
  const text = agrees ? "ER✓" : "ER✗";
  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      style={{
        position: "absolute",
        top: 2,
        left: 36,
        zIndex: 4,
        minWidth: 28,
        height: 14,
        padding: "0 4px",
        borderRadius: 4,
        fontSize: 8,
        fontWeight: 800,
        letterSpacing: 0.15,
        lineHeight: "12px",
        background: tone.bg,
        color: tone.color,
        border: `1.5px solid ${tone.border}`,
        cursor: "pointer",
        fontFamily: "DM Sans, sans-serif",
      }}
    >
      {text}
    </button>
  );
}

export function erganiGridHint(internalValue, erganiRow, lang) {
  const state = erganiMarkerState(internalValue, erganiRow);
  if (state === ERGANI_MARK.HIDDEN) return "";
  const gr = lang === "gr";
  const published = erganiRow ? erganiComparableValue(erganiRow) || erganiRow.shift_value : "";
  if (state === ERGANI_MARK.MATCH) {
    if (!published) return "";
    return gr ? `Εργάνη: ${published}` : `Ergani: ${published}`;
  }
  if (state === ERGANI_MARK.MISSING) return gr ? "Όχι στο Εργάνη" : "Not in Ergani";
  return gr ? `Εργάνη ${published || "—"}` : `Ergani ${published || "—"}`;
}
